/**
 * Ambient background image for the home screen. Replaces the previous SVG
 * pitch markings while leaving the surrounding conic sweep + grain layers
 * untouched. The .home-pitch-svg class keeps the existing positioning,
 * opacity and z-index treatment from home.css.
 */
import backgroundUrl from "./background.jpg";

export function PitchBackdrop() {
  return (
    <img className="home-pitch-svg" src={backgroundUrl} alt="" aria-hidden draggable={false} />
  );
}
